import type { TRouteId } from '$src/generated/routeIds';
import type { TMarket } from '$src/lib/services/market/types';
import { isLisOnlyRoute } from '$src/lib/services/routing/lis-routes';
import { redirect } from '@sveltejs/kit';
import ROUTE_IDS from '$src/generated/routeIds';
import { goto } from '$app/navigation';

export type TAuthGuardParams = {
    isLoggedIn: boolean;
    pathname: string;
    market: TMarket;
    navigationSlugs: Record<TRouteId, string>;
};

export type TAuthGuardResult = {
    path: string;
    status: number;
} | null;

export const createRouteGuardAuth = ({
    isLoggedIn,
    pathname,
    market,
    navigationSlugs
}: TAuthGuardParams): TAuthGuardResult => {
    if (!isLoggedIn && isLisOnlyRoute(pathname, market)) {
        return {
            path: navigationSlugs[ROUTE_IDS['/log-in']],
            status: 307
        };
    }
    return null;
};

export const routeGuardAuthSSR = (args: TAuthGuardParams): void => {
    const result = createRouteGuardAuth(args);
    if (result) {
        redirect(result.status, result.path);
    }
};

export const routeGuardAuthClient = (args: TAuthGuardParams): void => {
    const result = createRouteGuardAuth(args);
    if (result) {
        goto(result.path);
    }
};
